// extracted by mini-css-extract-plugin
export var title = "PrivateForm-module--title--1r2mP";
export var form = "PrivateForm-module--form--1sqW0";
export var submitContainer = "PrivateForm-module--submitContainer--1aFMM";
export var success = "PrivateForm-module--success--2RfeG";
export var submit = "PrivateForm-module--submit--1ETnl";